function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';
import classnames from 'classnames';
import Immutable from 'immutable';
import WebformContainer from '../WebformContainer';
import WebformActions from '../WebformActions';
import WebformStepCounter from '../WebformStepCounter';
var WebformWizardPage = function WebformWizardPage(props) {
  var entity = props.entity,
    currentPage = props.currentPage,
    pages = props.pages,
    showActions = props.showActions;
  var classes = classnames('WebformWizardPage', {
    hidden: currentPage !== entity.get('#webform_key')
  });
  var hasPageActions = function hasPageActions(entity) {
    var currentPage = props.currentPage;
    var objectFound = false;
    // Check on type 'webform_actions' and if these are actions for this page.
    var children = Immutable.fromJS(entity);
    children.entrySeq().forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        element = _ref2[1];
      if (key.indexOf('#') !== 0) {
        if (element.get('#type') === 'webform_actions' && element.get('#webform_parent_key') === currentPage) {
          objectFound = element;
        }
        // Recursively loop over children if we have not found.
        if (!objectFound) {
          var currentChildren = element;
          element.keySeq().forEach(function (k) {
            if (k.indexOf('#') === 0) {
              currentChildren = currentChildren.delete(k);
            }
          });
          objectFound = hasPageActions(currentChildren);
        }
      }
    });
    return objectFound;
  };
  if (currentPage !== entity.get('#webform_key')) {
    return null;
  }
  var pageAction = hasPageActions(entity);
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement(WebformStepCounter, {
    pages: pages,
    currentPage: currentPage
  }), entity.get('#format') !== 'container' && /*#__PURE__*/React.createElement("h2", {
    className: "WebformWizardPage__title"
  }, entity.get('#admin_title')), /*#__PURE__*/React.createElement("div", {
    className: "WebformWizardPage__divider"
  }), /*#__PURE__*/React.createElement(WebformContainer, props), showActions && !pageAction && /*#__PURE__*/React.createElement("div", {
    className: "WebformWizardPage__actions"
  }, /*#__PURE__*/React.createElement(WebformActions, _extends({}, props, {
    key: 'submit' + currentPage,
    entity: Immutable.Map({
      '#type': 'webform_actions',
      '#wizard_prev__label': entity.get('#prev_button_label'),
      '#wizard_next__label': entity.get('#next_button_label'),
      '#webform': currentPage,
      '#webform_id': "".concat(currentPage, "--actions"),
      '#webform_key': 'actions',
      '#webform_plugin_id': 'webform_actions'
    })
  }))));
};
export default WebformWizardPage;